import { render, staticRenderFns } from "./SalaryInquiryInfo.vue?vue&type=template&id=55a2d014&"
import script from "./SalaryInquiryInfo.vue?vue&type=script&lang=js&"
export * from "./SalaryInquiryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports